<script setup>
import { onMounted } from "vue";
import { useAuthStore } from "@digitalstreams/saas-core/vue/stores/authStore";

const auth = useAuthStore();

onMounted(() => {
  // Probe for an existing session cookie. Resolves quickly (one /get-session
  // call); router guards wait on auth.initialized before deciding to redirect.
  auth.init();
});
</script>

<template>
  <RouterView v-if="auth.initialized" />
  <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 100vh">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading…</span>
    </div>
  </div>
</template>
